export const QA_NAME_VIEWING_OUTCOME_NOTE = 'viewingOutcomeNote'
